export default __webpack_public_path__ + "static/media/departure.56ea5b62.svg";